module.exports = __webpack_public_path__ + "img/features-pic4.6c08b72.svg";